import { createSlice } from '@reduxjs/toolkit'
import laptop1 from "./productsImg/laptop1.jpg"
import laptop2 from "./productsImg/laptop2 (1).jpeg"
import laptop3 from "./productsImg/laptop3 (2).jpeg"
import monitor from "./productsImg/monitor.jpg"
import monitor2 from './productsImg/monitor1.jpg'
import monitor3 from './productsImg/monitor4.webp'


const initialState = {
    products: [
        {
          "id": 1,
          "name": "Playstation remote control",
          "firstImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-01.png",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-08.png",
          "price": 20,
          "stock": 3,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "white",
          "game": true,
          "disable": false,
          "category": "Accessories,Pc Gaming ",
    
        },
        {
          "id": 2,
          "name": "Sound System",
          "firstImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-04.png",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-05.png",
          "price": 70,
          "stock": 4,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "black",
          "disable": false,
          "category": "Compyuter, Accessories, Laptops",
        },
        {
          "id": 3,
          "name": "RGB keyboard",
          "firstImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-02.png",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-02.png",
          "price": 120,
          "stock": 5,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "black",
          "disable": false,
          "category": "Compyuter, Accessories, Laptops , Pc Gaming",
        },
        {
          "id": 4,
          "name": "Mouse",
          "firstImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-06.png",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-06.png",
          "price": 190,
          "stock": 5,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "black",
          "disable": false,
          "category": "Compyuter, Accessories , Laptops , Pc Gaming",
        },
        {
          "id": 5,
          "name": "Headphone",
          "firstImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-07.png",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-07.png",
          "price": 260,
          "stock":4,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "black",
          "disable": false,
          "category": "Phones, Compyuter ,Accessories, Laptops, Pc Gaming, Headphones",
        },
        {
          "id": 6,
          "name": "Camera",
          "firstImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-03.png",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-03.png",
          "price": 330,
          "stock":3,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "white",
          "disable": false,
          "category": "Camera",
        },
        {
          "id": 7,
          "name": "Wireless Headset",
          "firstImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-05.png",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-03.png",
          "price": 400,
          "stock": 5,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "black",
          "disable": false,
          "category": "Phones, Compyuter, Accessories, Pc Gaming, Headphones",
        },
        {
          "id": 9,
          "name": "Playstation remote control",
          "firstImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-08.png",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-08.png",
          "price": 470,
          "stock":4,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "blue",
          "disable": false,
          "category": " Laptops, Pc Gaming",
        },
        {
          "id": 10,
          "name": "Smart Watch",
          "firstImg": "https://ae04.alicdn.com/kf/Sa7ca866fe40f4e1cb1f4e249f1ded8eaJ/Y20-P8-Plus-IP68.jpg_640x640.jpg",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-08.png",
          "price": 540,
          "stock":3,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "black",
          "disable": false,
          "category": "Accessories, Smartwatches",
        },
        {
          "id": 11,
          "name": "Tablet",
          "firstImg": "https://ae04.alicdn.com/kf/S02a9f904da0944f6ace3f8721af39dd0F/P80-8-Android-10-4G-Wi-Fi-6-128-1280-800.jpg_640x640.jpg",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-08.png",
          "price": 610,
          "stock": 5,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "black",
          "disable": false,
          "category": "Phones, Laptops",
        },
        {
          "id": 12,
          "name": "Tablet",
          "firstImg": "https://ae01.alicdn.com/kf/S9e0b2d0c33d24aa4887366fc0068f25by.jpg?width=1000&height=1000&hash=2000",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-08.png",
          "price": 780,
          "stock":4,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "grey",
          "disable": false,
          "category": "Phones, Laptops",
        },
        {
          "id": 13,
          "name": "Phone",
          "firstImg": "https://www.att.com/idpassets/sales/uf/homepage/iconic/1284952_3up_lifestyle_below_tile_iPhone13Pro_AlpineGreen_w-retina.jpg",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-08.png",
          "price": 850,
          "stock": 3,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "green",
          "disable": false,
          "category": "Phones",
        },
        {
          "id": 14,
          "name": "Tablet",
          "firstImg": "https://ae04.alicdn.com/kf/Saf10a6b914564dbc8555448fa1c5811cy/DONGPAD-Android-11-0-8-128-11-6-4k-HD-Snapdragon.jpg_640x640.jpg",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-08.png",
          "price": 920,
          "stock": 5,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "grey",
          "disable": false,
          "category": "Phones, Laptops",
        },
        {
          "id": 15,
          "name": "Phone",
          "firstImg": "https://ae04.alicdn.com/kf/Sc5aea57fe23a46dc8290b5e26013c3cfK/Nothing-Phone-1-Qualcomm-Snapdragon-778G.png_640x640.png",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-08.png",
          "price": 990,
          "stock": 4,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "red",
          "disable": false,
          "category": "Phones",
        },
        {
          "id": 16,
          "name": "Phone",
          "firstImg": "https://ae04.alicdn.com/kf/Se6d45af48fec404c8a0def9650d045baB/HONOR-X9-HONOR-RAM-Turbo-4800-66-SuperCharge-90.jpg_640x640.jpg",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-08.png",
          "price": 1060,
          "stock": 3,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "blue",
          "disable": false,
          "category": "Phones",
        },
        {
          "id": 17,
          "name": "Smart Watch",
          "firstImg": "https://ae04.alicdn.com/kf/S17e5b16a6c964880b27fd21a1586f92fS/Xiaomi-Samsung-Android-2022.jpg_640x640.jpg",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-08.png",
          "price": 1130,
          "stock": 5,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "yellow",
          "disable": false,
          "category": "Smartwatches, Accessories ",
        },
        {
          "id": 18,
          "name": "Smart Watch",
          "firstImg": "https://ae04.alicdn.com/kf/S94ff1ab110044873aa2961f76d0b97f3M/2022-Bluetooth.jpg_640x640.jpg",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-08.png",
          "price": 1200,
          "stock": 4,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "white",
          "disable": false,
          "category": "Smartwatches, Accessories ",
        },
        {
          "id": 19,
          "name": "Mouse",
          "firstImg": "https://ae01.alicdn.com/kf/S05ce48a47b284ac6a36c9af8eb3730b9f.jpg?width=1000&height=1000&hash=2000",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-08.png",
          "price": 1270,
          "stock": 3,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "black",
          "disable": false,
          "category": "Accessories, Compyuter, Laptops",
        },
        {
          "id": 20,
          "name": "Headphone",
          "firstImg": "https://ae04.alicdn.com/kf/S5cc85f3914414843bbeaff0a29458054Y/A6s-Bluetooth-TWS-E7s-Touch-Mini.jpg_640x640.jpg",
          "secondImg": "https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-08.png",
          "price": 1340,
          "stock": 5,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "black",
          "disable": false,
          "category": "Headphones, Accessories",
        },
        {
          "id": 21,
          "name": "Laptop",
          "firstImg":laptop1 ,
          "price": 1340,
          "stock": 4,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "white",
          "disable": false,
          "category": "Compyuter, Laptops, Pc Gaming",
        },
        {
          "id": 22,
          "name": "Laptop",
          "firstImg":laptop2 ,
          "price": 2340,
          "stock": 3,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "white",
          "disable": false,
          "category": "Compyuter, Laptops, Pc Gaming",
        },
        {
          "id": 23,
          "name": "Laptop",
          "firstImg":laptop3 ,
          "price": 340,
          "stock": 5,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "white",
          "disable": false,
          "category": "Compyuter, Laptops, Pc Gaming",
        },
        {
          "id": 24,
          "name": "Monitor",
          "firstImg":monitor ,
          "price": 340,
          "stock": 4,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "black",
          "disable": false,
          "category": "Monitors Pc Gaming ",
        },
        {
          "id": 25,
          "name": "Monitor",
          "firstImg":monitor2 ,
          "price": 340,
          "stock": 3,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "black",
          "disable": false,
          "category": "Monitors,  Pc Gaming",
        },
        {
          "id": 26,
          "name": "Monitor",
          "firstImg":monitor3 ,
          "price": 340,
          "stock": 5,
          "count": 1,
          "saled": 30,
          "discountPercent": 0,
          "color": "white",
          "disable": false,
          "category": "Monitors Pc Gaming",
        }
      ]
}

const products = createSlice({
  name: "products",
  initialState,
  reducers: {}
});

export const {} = products.actions

export default products.reducer